import React from "react";
import Modal from "../../Modal";
import Button from "../../Button";
import styles from "./deleteConfirmModal.module.css";

const DeleteConfirmModal = ({
  show,
  onClose,
  onConfirm,
  loading = false,
  title = "Confirm Delete",
  description = "Are you sure you want to delete this record? This action cannot be undone.",
}) => {
  return (
    <Modal
      isOpen={show}
      onClose={onClose}
      title={title}
      size="medium"
      modalClassName={styles.deleteModal}
      titleClassName={styles.title}
      closeButtonClassName={styles.closeButton}
    >
      <div className={styles.body}>
        <div className={styles.iconWrap}>
          <i className="bi bi-trash3" />
        </div>
        <p className={styles.description}>{description}</p>

        <div className={styles.actions}>
          <Button
            type="button"
            variant="secondary"
            className="w-75"
            onClick={onClose}
            disabled={loading}
            // className={styles.cancelBtn}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="primary"
            className="w-75"
            onClick={onConfirm}
            loading={loading}
            // className={styles.deleteBtn}
          >
            Delete
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
